import { orchestrator } from 'satcheljs';
import {
    discardEvent,
    discardQuickComposeEvent,
    prepareEvent,
    presentDiscardClosureConfirmation,
} from 'owa-calendar-compose-form-actions';
import getQuickComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getQuickComposeViewState';
import { QuickComposePivotType } from 'owa-calendar-helpers-types/lib/ComposeTypes';

orchestrator(discardQuickComposeEvent, () => {
    const viewState = getQuickComposeViewState();
    if (viewState.activePivot === QuickComposePivotType.Event) {
        prepareEvent();
    }

    if (viewState.viewType == 'TimePanel') {
        // If it is timepanel, we show confirmation dialog
        presentDiscardClosureConfirmation();
    } else {
        discardEvent();
    }
});
